import { UPDATE_SALES_BY_SKU_WIDGET } from "./actionTypes"

export const updateSalesBySkuWidget = data => {
  return {
    type: UPDATE_SALES_BY_SKU_WIDGET,
    payload: data,
  }
}
